import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import useCategories from 'Hooks/useCategories';
import Select from 'Components/Atoms/Select/Select';
import { cn } from 'Utils/cn';

export default function RHFCategorySelect({ name, className, ...other }) {
    const { control } = useFormContext();
    const { categories, isLoading } = useCategories();

    if (isLoading) return <div style={{ height: 56 }} />;

    const categoryOptions = categories.map((category) => ({
        value: category.id,
        label: `${category.icon} ${category.name}`,
    }));

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Select
                    value={field.value}
                    onChange={field.onChange}
                    options={categoryOptions}
                    error={error?.message}
                    className={cn('w-full', className)}
                    {...other}
                />
            )}
        />
    );
}

RHFCategorySelect.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
};
